import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggleMenu: 'toggleMenu'
            }
        }
    }

    init() {
        this.menuMobile = document.querySelector('.menuMobile');
        this.menuToggle = this.el.querySelector('.c-navbar_menuToggle');

        window.addEventListener('updateNavbarStyle', (e) => {
            const { target, way, from } = e.detail;

            if (way == 'enter' && target.classList.contains('is-inview') && !target.closest('[data-load-container]').classList.contains('is-old')) {
                let style = target.getAttribute('data-style');
                // console.log(target.closest('[data-load-container]'));
                // console.log("style", target, style);
                // console.log("------------------------");
                this.setStyle(style);
            }
        });
    }

    hide(){
        this.el.classList.add('-hidden');
    }

    show() {
        this.el.classList.remove('-hidden');
    }

    setStyle(style) {
        this.el.setAttribute('data-style', style);
    }

    setLight() {
        this.setStyle('light');
    }

    resetStyle() {
        this.setStyle('transparent');
    }

    toggleMenu() {
        if (this.menuMobile.classList.contains('-visible')) {
            this.call('start', 'Scroll');
            this.menuMobile.classList.remove('-visible');
            this.menuToggle.classList.remove('-active');
            this.el.classList.remove('-menu-open');
        } else {
            this.call('stop', 'Scroll');
            this.menuMobile.classList.add('-visible');
            this.menuToggle.classList.add('-active');
            this.el.classList.add('-menu-open');
        }
    }

}
